import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { JA_SERVICES } from "@/data/ja-service-content";
import { SEO_SITE, multiHreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const PATH = "/ja/services";
const C = JA_SERVICES;

export const Route = createFileRoute("/ja/services")({
  head: () => ({
    meta: [
      { title: ctaTitle("バンコク 日本語対応 法律・公証・翻訳・ビザ ワンストップ | NYC Legal", "/ja/services", "th")},
      { name: "description", content: ctaDesc("バンコク Asok のリーガルファーム。公証・翻訳・アポスティーユ・国際結婚・ビザ・労働許可・法人設立・税務申告を日本人スタッフが日本語で対応。. Start with a free review before you file anything.", "/ja/services", "th")},
      { property: "og:title", content: ctaTitle("バンコク 日本語リーガル ワンストップ | NYC Legal", "/ja/services", "th")},
      { property: "og:description", content: ctaDesc("在タイ日本人のための総合リーガルサービス。LINE で無料相談。", "/ja/services", "th")},
      { property: "og:url", content: `${SEO_SITE}${PATH}` },
      { property: "og:locale", content: "ja_JP" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${PATH}` },
      ...multiHreflangLinks(
        [
          { hreflang: "th-TH", path: "/services" },
          { hreflang: "en", path: "/en/services" },
          { hreflang: "zh", path: "/zh/services" },
          { hreflang: "ja", path: "/ja/services" },
          { hreflang: "x-default", path: "/services" },
        ],
        "/services",
      ),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LegalService",
          name: "NYC Legal & Notary — Japanese Desk",
          url: `${SEO_SITE}${PATH}`,
          areaServed: ["TH", "JP"],
          inLanguage: "ja",
          priceRange: "฿1,500–฿50,000",
          provider: { "@type": "LegalService", name: "NYC Language Institute", url: SEO_SITE },
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          inLanguage: "ja",
          mainEntity: C.faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "ホーム", item: `${SEO_SITE}/ja` },
            { "@type": "ListItem", position: 2, name: "サービス", item: `${SEO_SITE}${PATH}` },
          ],
        }),
      },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
